<template>
  <div
    class="mb-4 flex w-full shrink-0 justify-between py-2"
  >
    <slot>
      <slot name="title">
        <PageTitle class="hidden lg:block">
          {{ pageTitle }}
        </PageTitle>
      </slot>
      <div class="ml-auto">
        <slot name="after" />
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
const { pageTitle } = usePageTitle()
</script>
